import { styled } from '@material-ui/core/styles';
import { TableCell } from '@material-ui/core';

export default styled(TableCell)((props) => ({
  width: props.width || 'auto',
}));
